import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsService } from 'src/app/services/settings.service';
import { AplicacionTipo } from 'src/app/_models/aplicacion-tipo';
import { MetodosServicio } from 'src/app/_helpers/interfaces/metodos-servicio';

@Injectable()
export class AplicacionTipoService extends MetodosServicio<AplicacionTipo>{

  constructor(
    public http: HttpClient,
    private settings: SettingsService
  ) {
    super(http, 'public/aplicacion_tipo', AplicacionTipo);
  }
  restartItem(): void {
    this.setItem(new AplicacionTipo());
  }

  /**
   * Método para obtener la aplicacion de una persona según su id
   * @param aplicacionTipoID identificador de aplicacion
   */
  obtenerAplicacionTipo(filtro: any): Observable<any> {
    return this.http.get(this.settings.URL_BASE + 'public/aplicacion_tipo',filtro);
  }

  crearAplicacionTipo(data: any): Observable<any> {
    return this.http.post(this.settings.URL_BASE + 'public/aplicacion_tipo', data);
  }

  actualizarAplicacionTipo(data: any, id: any): Observable<any> {
    return this.http.put(this.settings.URL_BASE + 'public/aplicacion_tipo/' + id, data);
  }

  eliminarAplicacionTipo(id: any): Observable<any> {
    return this.http.delete(this.settings.URL_BASE + 'public/aplicacion_tipo/' + id);
  }
}
